import React, { useState, useEffect } from "react";

import "./parallax-row.styles.scss";

type ParallaxRowProps = {
  children?: React.ReactNode;
  background: string;
  alt: string;
  height?: string | number;
};

const ParallaxRow: React.FC<ParallaxRowProps> = ({
  children,
  background,
  alt,
  height,
}) => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => setOffset(window.pageYOffset);
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="parallax-background"
      style={{
        height: height ?? undefined,
      }}
    >
      <img
        className="parallax-image"
        src={background}
        alt={alt}
        loading="eager"
        fetchPriority="high"
        decoding="async"
        style={{
          transform: `translateY(${offset / 5}px)`,
        }}
      />
      <div className="info-container" style={{ bottom: offset }}>
        {children}
      </div>
    </div>
  );
};

export default ParallaxRow;
